class Calculator {
    add(a, b) {
        return a + b;
    }

    sub(a, b) {
        return a -b;
    }
}

// Exporting a singleton calculator
export const calculator = new Calculator();
// could rename to calculator to math...
// export const math = new Calculator();
